module.exports = __webpack_public_path__ + "static/img/guess_words_title.95ad7a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guess_word/guess_words_title.png
// module id = skZD
// module chunks = 1